import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  QUESTION_OPEN_ENDED,
  MINIMUM_POSTAL_CODE_LENGTH,
} from '../../constants';
import ABConceptAttributes from './AbConceptAttributes';
import QuestionMedia from '../QuestionMedia';
import { transformMediaQuestionAttributes } from './utils';
import DescriptiveText from './DescriptiveText';
import SubmitButton from '../SubmitButton';
import Answers from '../Answers';
import QuestionBody from '../QuestionBody';
import QuestionPrompt from '../QuestionPrompt';

export default function Question({ question }) {
  const { getText } = Pollfish.ui;

  const mediaAttributes = transformMediaQuestionAttributes({
    ...question,
    questionRefId: question.refId,
  });

  const submitBtnProps = {
    onTap: Pollfish.ui.loadQuestionOrThankScreen.bind(Pollfish.ui),
  };
  if (
    question.style === QUESTION_OPEN_ENDED &&
    question.f_name === 'dg_postal_data'
  ) {
    submitBtnProps.onTap = () => {
      const postalCodeValue = Pollfish.helper.getPostalCodeValue();
      const selectedPostalCode = Pollfish.helper.getPostalCodeSelection();
      const selectedPostalCodeCountry = selectedPostalCode.attr(
        'data-postal-code-country',
      );
      const selectedPostalCodePlaceId = selectedPostalCode.attr(
        'data-postal-code-place-id',
      );
      const selectedPostalCodePreferNotToSay =
        selectedPostalCode.attr('data-postal-code-prefer-not-to-say') ===
        'true';
      if (
        postalCodeValue.length >= MINIMUM_POSTAL_CODE_LENGTH &&
        selectedPostalCode.length &&
        !selectedPostalCodeCountry &&
        !selectedPostalCodePlaceId &&
        !selectedPostalCodePreferNotToSay
      ) {
        Pollfish.ui.showConfirmationModal({
          useHtmlContent: true,
          header: getText('warnings.noZipcode'),
          content: getText('warnings.verifyCustomZipcode').replace(
            'XXXXX',
            `<strong>${postalCodeValue}</strong>`,
          ),
          noBtnText: getText('tryAgain'),
          yesBtnText: getText('submit'),
          onConfirm: () => {
            Pollfish.ui.loadQuestionOrThankScreen();
          },
          style: {
            maxWidth: 400,
          },
          buttonStack: 'vertical',
        });
      } else {
        Pollfish.ui.loadQuestionOrThankScreen();
      }
    };
  }

  $('body').attr('data-page', `question-${question.id}`);
  if (question.f_name) {
    $('body').attr('data-f_name', question.f_name);
  } else {
    $('body').removeAttr('data-f_name');
  }

  const { groups } = Pollfish.survey;
  return (
    <Fragment>
      <div className="main-content__holder">
        <QuestionPrompt question={question} />
        <div className="answers-wrapper">
          <DescriptiveText
            isSanityQuestion={question.isSanityQuestion}
            getText={getText}
          />
          <ABConceptAttributes groups={groups} question={question} />
          <QuestionMedia {...mediaAttributes} />
          <QuestionBody question={question} />
          <Answers question={question} />
        </div>
      </div>
      <SubmitButton {...submitBtnProps} />
    </Fragment>
  );
}

Question.propTypes = {
  question: PropTypes.object,
};
